var GSAP_SCROLL = (function(GSAP_SCROLL, $, window, document, undefined){
  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;

  var motionDefaults = {
    motionSpanVh: 100,
    startYVh: 110,
    endYVh: -20,
    triggerLeadVh: 15,
    fadeInStart: 0.15,
    fadeInEnd: 0.25,
    fadeOutStart: 0.7,
    fadeOutEnd: 0.8,
    opacityStart: 0,
    opacityEnd: 0,
    blurPx: 10,
    // Extra viewport-heights after the motion so the next section waits.
    pinTailVh: 100
  };

  var fixedDefaults = {
    fadeInStart: 0.32,
    fadeInEnd: 0.45,
    fadeOutStart: 0.7,
    fadeOutEnd: 0.8,
    opacityStart: 0,
    opacityEnd: 0
  };

  function clamp01(v){
    if (v <= 0) {
      return 0;
    }
    if (v >= 1) {
      return 1;
    }
    return v;
  }

  function numberSetting($el, attrName, fallback){
    return UTIL.attrNumber($el, attrName, fallback);
  }

  function fadeWindow(start, end){
    if (!(end > start)) {
      end = start + 0.001;
    }
    return { start: start, end: end };
  }

  function opacityFromWindows(t, fadeIn, fadeOut, opacityStart, opacityEnd){
    var fadeInT = clamp01((t - fadeIn.start) / (fadeIn.end - fadeIn.start));
    var fadeOutT = clamp01((t - fadeOut.start) / (fadeOut.end - fadeOut.start));
    var opacity = opacityStart + ((1 - opacityStart) * fadeInT);
    return opacity + ((opacityEnd - opacity) * fadeOutT);
  }

  // Placeholder is often position:fixed at the bottom of the viewport.
  // Measure it in vh so pause/fade points are the same fraction of the screen
  // on every height.
  function placeholderTopVh(hostSection, vh){
    var el = hostSection.querySelector('.pause-placeholder');
    if (!el) {
      return null;
    }
    return (el.getBoundingClientRect().top / Math.max(1, vh)) * 100;
  }

  function yVhToMotionT(targetYVh, startYVh, endYVh){
    var span = endYVh - startYVh;
    if (Math.abs(span) < 0.001) {
      return null;
    }
    return (targetYVh - startYVh) / span;
  }

  function offsetMotionT($el, panel, hostSection, startYVh, endYVh, vh, offsetAttr, atBottom){
    var offsetRaw = UTIL.attr($el, offsetAttr);
    if (offsetRaw == null || String(offsetRaw).trim() === '') {
      return null;
    }
    var phTopVh = placeholderTopVh(hostSection, vh);
    if (phTopVh == null) {
      return null;
    }
    var offsetVh = UTIL.lengthToVh(offsetRaw, panel);
    var targetYVh = phTopVh - offsetVh;
    if (atBottom) {
      targetYVh -= (panel.offsetHeight / Math.max(1, vh)) * 100;
    }
    return yVhToMotionT(targetYVh, startYVh, endYVh);
  }

  function fadeProgressSetting($el, panel, hostSection, startYVh, endYVh, vh, offsetAttr, progressAttr, fallback, atBottom){
    var t = offsetMotionT($el, panel, hostSection, startYVh, endYVh, vh, offsetAttr, atBottom);
    if (t != null && Number.isFinite(t)) {
      return t;
    }
    return numberSetting($el, progressAttr, fallback);
  }

  function resolvePause($panel, panel, hostSection, startYVh, endYVh, vh){
    var pauseRaw = UTIL.attr($panel, 'data-intro-pause-for');
    if (pauseRaw == null || String(pauseRaw).trim() === '') {
      return null;
    }
    var pauseVh = UTIL.lengthToVh(pauseRaw, panel);
    if (!(pauseVh > 0)) {
      return null;
    }
    var pauseAtRaw = UTIL.attr($panel, 'data-intro-pause-at');
    var pauseAtNorm = (pauseAtRaw == null) ? '' : String(pauseAtRaw).trim().toLowerCase();
    var t;
    if (pauseAtNorm !== '' && pauseAtNorm !== 'bottom') {
      t = parseFloat(pauseAtNorm);
      if (!Number.isFinite(t)) {
        return null;
      }
    } else {
      t = offsetMotionT($panel, panel, hostSection, startYVh, endYVh, vh, 'data-intro-pause-offset', pauseAtNorm === 'bottom');
      if (t == null && pauseAtNorm === 'bottom') {
        t = offsetMotionT($panel, panel, hostSection, startYVh, endYVh, vh, 'data-intro-pause-offset', true);
      }
      if (t == null) {
        var phTopVh = placeholderTopVh(hostSection, vh);
        if (phTopVh == null) {
          return null;
        }
        var targetYVh = phTopVh;
        if (pauseAtNorm === 'bottom') {
          targetYVh -= (panel.offsetHeight / Math.max(1, vh)) * 100;
        }
        t = yVhToMotionT(targetYVh - UTIL.lengthToVh(UTIL.attr($panel, 'data-intro-pause-offset') || '0', panel), startYVh, endYVh);
      }
    }
    if (t == null || !Number.isFinite(t)) {
      return null;
    }
    return {
      t: clamp01(t),
      pauseVh: pauseVh
    };
  }

  function applyFixedPanel(fixedPanel, t, ctx){
    var $fixedPanel = $(fixedPanel);
    if (t == null) {
      var hidden = clamp01(numberSetting($fixedPanel, 'data-content-fixed-opacity-start', fixedDefaults.opacityStart));
      fixedPanel.style.opacity = String(hidden);
      fixedPanel.style.visibility = (hidden <= 0.001) ? 'hidden' : 'visible';
      return;
    }
    var panel = ctx.panel;
    var hostSection = ctx.hostSection;
    var startYVh = ctx.startYVh;
    var endYVh = ctx.endYVh;
    var vh = ctx.vh;
    var atBottom = ctx.atBottom;
    var fadeIn = fadeWindow(
      fadeProgressSetting($fixedPanel, panel, hostSection, startYVh, endYVh, vh, 'data-content-fixed-fade-in-start-offset', 'data-content-fixed-fade-in-start', fixedDefaults.fadeInStart, atBottom),
      fadeProgressSetting($fixedPanel, panel, hostSection, startYVh, endYVh, vh, 'data-content-fixed-fade-in-end-offset', 'data-content-fixed-fade-in-end', fixedDefaults.fadeInEnd, atBottom)
    );
    var fadeOut = fadeWindow(
      fadeProgressSetting($fixedPanel, panel, hostSection, startYVh, endYVh, vh, 'data-content-fixed-fade-out-start-offset', 'data-content-fixed-fade-out-start', fixedDefaults.fadeOutStart, atBottom),
      fadeProgressSetting($fixedPanel, panel, hostSection, startYVh, endYVh, vh, 'data-content-fixed-fade-out-end-offset', 'data-content-fixed-fade-out-end', fixedDefaults.fadeOutEnd, atBottom)
    );
    var opacityStart = clamp01(numberSetting($fixedPanel, 'data-content-fixed-opacity-start', fixedDefaults.opacityStart));
    var opacityEnd = clamp01(numberSetting($fixedPanel, 'data-content-fixed-opacity-end', fixedDefaults.opacityEnd));
    var opacity = opacityFromWindows(t, fadeIn, fadeOut, opacityStart, opacityEnd);
    fixedPanel.style.opacity = String(opacity);
    fixedPanel.style.visibility = (opacity <= 0.001) ? 'hidden' : 'visible';
  }

  function applyPanel(panel, t, ctx){
    var $panel = $(panel);
    var yVh = ctx.startYVh + ((ctx.endYVh - ctx.startYVh) * t);
    panel.style.transform = 'translate3d(0, ' + yVh + 'svh, 0)';
    var opacity = opacityFromWindows(t, ctx.fadeIn, ctx.fadeOut, ctx.opacityStart, ctx.opacityEnd);
    var blurPx = ctx.blurPx * (1 - opacity);
    panel.style.opacity = String(opacity);
    panel.style.filter = (blurPx > 0.01) ? ('blur(' + blurPx + 'px)') : 'none';
    panel.style.visibility = (opacity <= 0.001) ? 'hidden' : 'visible';
    var fixedPanels = ctx.hostSection.querySelectorAll('.content-fixed');
    var i;
    for (i = 0; i < fixedPanels.length; i++) {
      applyFixedPanel(fixedPanels[i], t, ctx);
    }
  }

  function applyPanelHidden(panel, ctx){
    panel.style.transform = 'translate3d(0, ' + ctx.startYVh + 'svh, 0)';
    panel.style.opacity = String(ctx.opacityStart);
    panel.style.filter = (ctx.blurPx > 0 && ctx.opacityStart < 1) ? ('blur(' + ctx.blurPx + 'px)') : 'none';
    panel.style.visibility = (ctx.opacityStart <= 0.001) ? 'hidden' : 'visible';
    var fixedPanels = ctx.hostSection.querySelectorAll('.content-fixed');
    var i;
    for (i = 0; i < fixedPanels.length; i++) {
      applyFixedPanel(fixedPanels[i], null, ctx);
    }
  }

  // Map ScrollTrigger 0–1 (over motion + pause + tail) onto motion t 0–1,
  // holding t at pause.t for pauseVh of the distance.
  function motionTFromProgress(progress, motionVh, pause, tailVh){
    var pauseVh = pause ? pause.pauseVh : 0;
    var pauseAt = pause ? pause.t : 0;
    var totalVh = motionVh + pauseVh + tailVh;
    if (!(totalVh > 0)) {
      return 1;
    }
    var u = progress * totalVh;
    if (!pause || pauseVh <= 0) {
      if (u >= motionVh) {
        return 1;
      }
      return clamp01(u / Math.max(0.001, motionVh));
    }
    var pauseStart = pauseAt * motionVh;
    if (u <= pauseStart) {
      return clamp01(u / Math.max(0.001, motionVh));
    }
    if (u <= pauseStart + pauseVh) {
      return pauseAt;
    }
    var after = u - pauseVh;
    if (after >= motionVh) {
      return 1;
    }
    return clamp01(after / Math.max(0.001, motionVh));
  }

  function shouldPinSection(section){
    if (!section) {
      return false;
    }
    if (section.id === 'projects' || (section.parentElement && section.parentElement.id === 'work')) {
      return false;
    }
    if (section.id === 'case-hero') {
      return true;
    }
    if (section.closest && section.closest('#case-study')) {
      return true;
    }
    return false;
  }

  function triggerForPanel(panel, section){
    if (shouldPinSection(section)) {
      return section;
    }
    var selector = UTIL.attr(panel, 'data-intro-trigger');
    if (selector) {
      var el = document.querySelector(selector);
      if (el) {
        return el;
      }
    }
    var work = document.getElementById('work');
    if (work && section.id === 'projects' && work.contains(section)) {
      return work;
    }
    return section;
  }

  function buildPanelContext(panel){
    var $panel = $(panel);
    var hostSection = $panel.closest('section').get(0);
    if (!hostSection) {
      return null;
    }
    var vh = UTIL.svh() || 1;
    var startYVh = numberSetting($panel, 'data-intro-start-y-vh', motionDefaults.startYVh);
    var endYVh = numberSetting($panel, 'data-intro-end-y-vh', motionDefaults.endYVh);
    if (!Number.isFinite(startYVh)) {
      startYVh = motionDefaults.startYVh;
    }
    if (!Number.isFinite(endYVh)) {
      endYVh = motionDefaults.endYVh;
    }
    var pauseAtRaw = UTIL.attr($panel, 'data-intro-pause-at');
    var atBottom = pauseAtRaw != null && String(pauseAtRaw).trim().toLowerCase() === 'bottom';
    var fadeIn = fadeWindow(
      fadeProgressSetting($panel, panel, hostSection, startYVh, endYVh, vh, 'data-intro-fade-in-start-offset', 'data-intro-fade-in-start', motionDefaults.fadeInStart, atBottom),
      fadeProgressSetting($panel, panel, hostSection, startYVh, endYVh, vh, 'data-intro-fade-in-end-offset', 'data-intro-fade-in-end', motionDefaults.fadeInEnd, atBottom)
    );
    var fadeOut = fadeWindow(
      fadeProgressSetting($panel, panel, hostSection, startYVh, endYVh, vh, 'data-intro-fade-out-start-offset', 'data-intro-fade-out-start', motionDefaults.fadeOutStart, atBottom),
      fadeProgressSetting($panel, panel, hostSection, startYVh, endYVh, vh, 'data-intro-fade-out-end-offset', 'data-intro-fade-out-end', motionDefaults.fadeOutEnd, atBottom)
    );
    return {
      panel: panel,
      hostSection: hostSection,
      vh: vh,
      startYVh: startYVh,
      endYVh: endYVh,
      fadeIn: fadeIn,
      fadeOut: fadeOut,
      opacityStart: clamp01(numberSetting($panel, 'data-intro-opacity-start', motionDefaults.opacityStart)),
      opacityEnd: clamp01(numberSetting($panel, 'data-intro-opacity-end', motionDefaults.opacityEnd)),
      blurPx: Math.max(0, numberSetting($panel, 'data-intro-blur-px', motionDefaults.blurPx)),
      motionSpanVh: numberSetting($panel, 'data-intro-motion-span-vh', motionDefaults.motionSpanVh) || motionDefaults.motionSpanVh,
      triggerLeadVh: numberSetting($panel, 'data-intro-trigger-lead-vh', motionDefaults.triggerLeadVh),
      pause: resolvePause($panel, panel, hostSection, startYVh, endYVh, vh),
      atBottom: atBottom
    };
  }

  function bindContentScroll(){
    var seen = [];
    var panels = document.querySelectorAll('.content-scroll');
    var i;
    for (i = 0; i < panels.length; i++) {
      (function(panel){
        var ctx = buildPanelContext(panel);
        if (!ctx) {
          return;
        }
        var section = ctx.hostSection;
        if (seen.indexOf(section) !== -1) {
          return;
        }
        seen.push(section);

        var wrap = section.parentElement && section.parentElement.classList.contains('content-scroll-pin-wrap')
          ? section.parentElement
          : null;
        var trigger = wrap || triggerForPanel(panel, section);

        function currentCtx(){
          ctx = buildPanelContext(panel) || ctx;
          return ctx;
        }

        function applyFromProgress(progress){
          var c = currentCtx();
          var pauseVh = c.pause ? c.pause.pauseVh : 0;
          var tailVh = 0;
          if (wrap) {
            var totalVh = (wrap.offsetHeight / Math.max(1, UTIL.scrollVh(panel))) * 100;
            tailVh = Math.max(0, totalVh - c.motionSpanVh - pauseVh);
          }
          var t = motionTFromProgress(progress, c.motionSpanVh, c.pause, tailVh);
          applyPanel(panel, t, c);
        }

        ScrollTrigger.create({
          trigger: trigger,
          start: 'top top',
          end: wrap ? 'bottom top' : function(){
            var c = currentCtx();
            var pauseVh = c.pause ? c.pause.pauseVh : 0;
            return '+=' + ((c.motionSpanVh + pauseVh) / 100) * UTIL.scrollVh(panel);
          },
          pin: false,
          scrub: true,
          invalidateOnRefresh: true,
          onUpdate: function(self){
            applyFromProgress(self.progress);
          },
          onLeaveBack: function(){
            applyPanelHidden(panel, currentCtx());
          },
          onLeave: function(){
            applyFromProgress(1);
          }
        });
        applyPanelHidden(panel, ctx);
      })(panels[i]);
    }
  }

  function bindScrollY(){
    var hosts = document.querySelectorAll('[data-scroll-y-start-vh], [data-scroll-start]');
    var i;
    for (i = 0; i < hosts.length; i++) {
      (function(host){
        function isReverse(){
          var reverseRaw = UTIL.attr(host, 'data-scroll-y-reverse');
          if (reverseRaw == null) {
            return false;
          }
          var reverseNorm = String(reverseRaw).trim().toLowerCase();
          return (reverseNorm === '' || reverseNorm === 'true' || reverseNorm === '1' || reverseNorm === 'reverse');
        }

        function triggerEl(){
          var selector = UTIL.attr(host, 'data-scroll-y-trigger');
          var trigger = selector ? document.querySelector(selector) : host;
          if (!trigger) {
            trigger = host;
          }
          if (trigger.parentElement && trigger.parentElement.classList.contains('content-scroll-pin-wrap')) {
            return trigger.parentElement;
          }
          if (window.getComputedStyle(trigger).position === 'fixed' && trigger.parentElement) {
            return trigger.parentElement;
          }
          return trigger;
        }

        function startValue(){
          var startPreset = UTIL.attr(host, 'data-scroll-start');
          var preset = startPreset == null ? '' : String(startPreset).trim().toLowerCase();
          var startYVh = UTIL.attrNumber(host, 'data-scroll-y-start-vh');
          if (startYVh == null) {
            startYVh = 0;
          }
          var offsetPct = UTIL.attrNumber(host, 'data-scroll-y-start-offset');
          if (offsetPct == null) {
            offsetPct = 0;
          }
          if (offsetPct < -100) {
            offsetPct = -100;
          }
          if (offsetPct > 100) {
            offsetPct = 100;
          }
          var vh = UTIL.svh();
          var trigger = triggerEl();
          // Positive start-vh / offset = start later. Negative start-vh = start sooner.
          var extraPx = ((startYVh / 100) * vh) + ((offsetPct / 100) * Math.max(1, trigger.offsetHeight));
          var view = 'top';
          if (preset === 'late') {
            view = '25%';
          } else if (preset === 'early' || (preset && !/^(complete|late)$/.test(preset) && !Number.isFinite(parseFloat(preset)))) {
            view = '75%';
          } else if (preset && Number.isFinite(parseFloat(preset)) && !/^(early|late|complete)$/.test(preset)) {
            extraPx += -(parseFloat(preset) / 100) * vh;
          }
          if (extraPx > 1) {
            return 'top+=' + Math.round(extraPx) + 'px ' + view;
          }
          if (extraPx < -1) {
            return 'top-=' + Math.round(-extraPx) + 'px ' + view;
          }
          if (view === 'top') {
            return 'top top';
          }
          return 'top ' + view;
        }

        var startYVh = UTIL.attrNumber(host, 'data-scroll-y-start-vh');
        if (startYVh == null && !host.hasAttribute('data-scroll-start')) {
          return;
        }

        host.style.setProperty('--scroll-y', isReverse() ? '100' : '0');

        ScrollTrigger.create({
          trigger: function(){
            return triggerEl();
          },
          start: startValue,
          end: function(){
            var spanVh = UTIL.attrNumber(host, 'data-scroll-y-span-vh');
            if (spanVh == null || spanVh <= 0) {
              spanVh = 100;
            }
            var factor = UTIL.attrNumber(host, 'data-scroll-y-factor');
            if (factor == null || factor <= 0) {
              factor = 1;
            }
            return '+=' + (spanVh / 100 / factor) * UTIL.scrollVh(host);
          },
          scrub: 0.25,
          invalidateOnRefresh: true,
          onUpdate: function(self){
            var value = self.progress * 100;
            if (isReverse()) {
              value = 100 - value;
            }
            host.style.setProperty('--scroll-y', String(value));
          }
        });
      })(hosts[i]);
    }
  }

  function bindStandaloneFixed(){
    var seen = [];
    $('.content-fixed').each(function(){
      var section = this.closest('section');
      if (!section || seen.indexOf(section) !== -1) {
        return;
      }
      if ($(section).find('.content-scroll').length) {
        seen.push(section);
        return;
      }
      seen.push(section);
      ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: function(){
          return '+=' + Math.max(UTIL.svh(), section.offsetHeight);
        },
        scrub: true,
        invalidateOnRefresh: true,
        onUpdate: function(self){
          var panels = section.querySelectorAll('.content-fixed');
          var j;
          for (j = 0; j < panels.length; j++) {
            applyFixedPanel(panels[j], self.progress, {
              panel: panels[j],
              hostSection: section,
              startYVh: 0,
              endYVh: 100,
              vh: UTIL.svh()
            });
          }
        },
        onLeaveBack: function(){
          var panels = section.querySelectorAll('.content-fixed');
          var j;
          for (j = 0; j < panels.length; j++) {
            applyFixedPanel(panels[j], null, {
              panel: panels[j],
              hostSection: section,
              startYVh: 0,
              endYVh: 100,
              vh: UTIL.svh()
            });
          }
        }
      });
    });
  }

  function init(){
    if (!gsap || !ScrollTrigger) {
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });
    bindContentScroll();
    bindScrollY();
    bindStandaloneFixed();
    ScrollTrigger.refresh();
    UTIL.onLayoutSettle(function(){
      ScrollTrigger.refresh();
    });
  }

  $(init);

  return GSAP_SCROLL;
})(window.GSAP_SCROLL || {}, jQuery, window, document);
